import { render, staticRenderFns } from "./CarisNatCodeHeader.vue?vue&type=template&id=5d51361a&scoped=true"
import script from "./CarisNatCodeHeader.vue?vue&type=script&lang=js"
export * from "./CarisNatCodeHeader.vue?vue&type=script&lang=js"
import style0 from "./CarisNatCodeHeader.vue?vue&type=style&index=0&id=5d51361a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d51361a",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fcaris-nat-code-header%2FCarisNatCodeHeader.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports